import { render, staticRenderFns } from "./customApplication.vue?vue&type=template&id=15189fee&scoped=true"
import script from "./customApplication.vue?vue&type=script&lang=js"
export * from "./customApplication.vue?vue&type=script&lang=js"
import style0 from "./customApplication.vue?vue&type=style&index=0&id=15189fee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15189fee",
  null
  
)

export default component.exports